<template>
  <div class="resources__cards">
    <div class="resources__card">
      <a :href="`/${$filters.convertResourceType(payload['resource-type'])}/${payload['slug']}`">
        <header class="resources__header" :style="`background-image:url('${payload['cover-image']}')`">
          <span :class="`resources__category pill ${pillColor}`">{{ payload['resource-type'] }}</span>
        </header>
        <div class="resources__body">
          <h4>{{ payload.title }}</h4>
          <ul class="resources__body-tags">
            <li v-for="(tag, t) in payload.collection" :key="t">{{ tag }}</li>
          </ul>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    payload: {
      type: Object
    },
  },

  computed: {
    pillColor() {
      let result = this.payload['resource-type'] ? this.payload['resource-type'].replace(/\s+/g, '-').toLowerCase() : 'default';
      return result;
    }
  }
};
</script>
